"use client";

import { useQuery } from "@tanstack/react-query";
import type { EssenceVersion } from "@/lib/db/schema";

export interface EssenceDetail {
  essence: { id: string; latestVersionNumber: number | null; viewCount: number; favoriteCount: number };
  version: EssenceVersion;
  history: { versionNumber: number; createdAt: string | Date }[];
  isLatest: boolean;
}

export function useEssenceDetail(id: string, version?: number) {
  return useQuery<EssenceDetail>({
    queryKey: ["essence", id, version],
    queryFn: async () => {
      const params = version ? `?version=${version}` : "";
      const response = await fetch(`/api/essences/${id}${params}`);
      if (!response.ok) throw new Error("Failed to load essence");
      return response.json();
    },
    staleTime: 2 * 60 * 1000,
  });
}
